var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBearishArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1.313 3.5 L 5.25 7.438 L 7.75 4.937 C 8.98 5.874 9.864 7.194 10.262 8.688 L 10.715 10.379 M 10.715 10.379 L 12.571 7.164 M 10.715 10.378 L 7.5 8.523",
    fill: "transparent",
    stroke: "rgb(179, 179, 179)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearishArrow);
export default __webpack_public_path__ + "static/media/BearishArrow.fd133a93e08777924fd2bbde46e59530.svg";
export { ForwardRef as ReactComponent };